import { defineStore } from 'pinia'
import { ref } from 'vue'

import type { PermissionsMatrix } from '@/types/api'

export const usePermissionsStore = defineStore('permissions', () => {
  const matrix = ref<PermissionsMatrix>({})

  function set(value: PermissionsMatrix): void {
    matrix.value = value ?? {}
  }

  function clear(): void {
    matrix.value = {}
  }

  /**
   * Verifica si el usuario actual puede ejecutar `action` sobre `resource`.
   * Acepta `'*'` como comodín que concede cualquier acción sobre el recurso.
   */
  function can(action: string, resource: string): boolean {
    const actions = matrix.value[resource]
    if (!actions || !Array.isArray(actions)) return false
    return actions.includes(action) || actions.includes('*')
  }

  return { matrix, set, clear, can }
})
